import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconTrendingUp = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M3 17l6-6 4 4 8-8' />
      <path d='M15 7h6v6' />
    </g>
  </SDIcon>
)

export default IconTrendingUp
